import React, { useState, useEffect } from 'react';
import { Icons } from '@/assets';

const NumberInput = ({
  label,
  value = 1,
  onChange,
  onIncrement,
  onDecrement,
  onInputChange,
  error,
  min = 1,
  className = '',
  disabled = false,
  placeholder = '',
}) => {
  const [displayValue, setDisplayValue] = useState(value);

  // Sync displayValue with value prop
  useEffect(() => {
    setDisplayValue(value.toString());
  }, [value]);

  const handleIncrement = () => {
    console.log(
      'Increment clicked, onIncrement:',
      !!onIncrement,
      'onChange:',
      !!onChange,
      'value:',
      value
    );
    if (onIncrement) {
      onIncrement();
    } else if (onChange) {
      onChange(Math.max(min, (parseInt(value) || min) + 1));
    }
  };

  const handleDecrement = () => {
    console.log(
      'Decrement clicked, onDecrement:',
      !!onDecrement,
      'onChange:',
      !!onChange,
      'value:',
      value
    );
    if (onDecrement) {
      onDecrement();
    } else if (onChange) {
      onChange(Math.max(min, (parseInt(value) || min) - 1));
    }
  };

  const handleInputChange = (inputValue) => {
    setDisplayValue(inputValue);
    if (onInputChange) {
      onInputChange(inputValue);
    } else if (onChange) {
      const numericValue = inputValue.replace(/[^0-9]/g, '');
      const numValue = parseInt(numericValue) || min;
      const validValue = Math.max(min, numValue);
      onChange(validValue);
    }
  };

  const handleBlur = () => {
    // If input is empty when user clicks outside, set it to min value (1)
    if (!displayValue || displayValue.trim() === '') {
      setDisplayValue(min.toString());
      if (onChange) {
        onChange(min);
      }
    }
  };

  return (
    <div className={`flex flex-col ${className}`}>
      {label && (
        <span className="text-sm text-primary-text font-bold">{label}</span>
      )}
      <div className="box-border mt-2 px-3 flex items-center h-12 border border-solid border-gray-300 rounded-md overflow-hidden hover:border-primary-text focus-within:border-primary-text transition-colors duration-200">
        <button
          type="button"
          onClick={handleDecrement}
          className="appearance-none bg-transparent p-0 m-0 cursor-pointer border-none flex items-center justify-center"
          disabled={disabled || value <= min}>
          <img
            src={Icons.minusSquare}
            alt="minus"
            width="22"
            height="22"
            style={{ pointerEvents: 'none' }}
          />
        </button>

        <input
          type="text"
          value={displayValue}
          onChange={(e) => handleInputChange(e.target.value)}
          onBlur={handleBlur}
          className="flex-1 px-3 text-center border-0 focus:outline-none focus:ring-0"
          disabled={disabled}
          placeholder={placeholder}
        />

        <button
          type="button"
          onClick={handleIncrement}
          className="appearance-none bg-transparent p-0 m-0 cursor-pointer border-none flex items-center justify-center"
          disabled={false}>
          <img
            src={Icons.plusSquare}
            alt="plus"
            width="22"
            height="22"
            style={{ pointerEvents: 'none' }}
          />
        </button>
      </div>
      {error && <span className="text-red-500 text-xs mt-1">{error}</span>}
    </div>
  );
};

export default NumberInput;
